import {
  FETCH_AUDIENCE_PREVIEW,
  FETCH_AUDIENCE_PREVIEW_SUCCESS,
  SET_AUDIENCE_TYPE,
  SET_INDUSTRY_ACTION,
  SET_ORGANISATION_ACTION,
  SET_AUDIENCE_BUILDER_DATA_SOURCE,
  SET_AUDIENCE_DATE_RANGE,
  CREATE_AUDIENCE,
  CREATE_AUDIENCE_SUCCESS,
  FETCH_INTEGRATIONS,
  FETCH_INTEGRATIONS_SUCCESS,
  SET_HOME_ACTION,
} from '../constants';

import moment from 'moment';

const initialState = {
  audiencePreviewDataLoaded: false,
  audiencePreviewData: {},
  audienceType: '',
  industry: [],
  organisation: [],
  home: [],
  dataSource: 'all',
  since: moment()
    .subtract(365, 'days')
    .startOf('day')
    .format(),
  until: moment()
    .subtract(1, 'days')
    .endOf('day')
    .format(),
  audienceCreating: false,
  audienceId: '',
  integrations: [],
  integrationsLoaded: false,
};

const audienceBuilder = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_AUDIENCE_PREVIEW:
      return {
        ...state,
        audiencePreviewDataLoaded: false,
      };
    case FETCH_AUDIENCE_PREVIEW_SUCCESS:
      return {
        ...state,
        audiencePreviewDataLoaded: true,
        audiencePreviewData: action.data,
      };
    case SET_AUDIENCE_TYPE:
      return {
        ...state,
        audienceType: action.typeName,
      };
    case SET_INDUSTRY_ACTION:
      return {
        ...state,
        industry: action.data,
      };
    case SET_ORGANISATION_ACTION:
      return {
        ...state,
        organisation: action.data,
      };
    case SET_HOME_ACTION:
      return{
        ...state,
        home: action.data,
      }
    case SET_AUDIENCE_BUILDER_DATA_SOURCE:
      return {
        ...state,
        dataSource: action.dataSource,
      };
    case SET_AUDIENCE_DATE_RANGE:
      return {
        ...state,
        since: action.since,
        until: action.until,
      };
    case CREATE_AUDIENCE:
      return{
        ...state,
        audienceCreating: true,
      };
    case CREATE_AUDIENCE_SUCCESS:
      return {
        ...state,
        audienceId: action.data.id,
        audienceCreating: false,
      };
    case FETCH_INTEGRATIONS:
      return {
        ...state,
        integrationsLoaded: false,
      };
    case FETCH_INTEGRATIONS_SUCCESS:

      return {
        ...state,
        integrations: action.data,
        integrationsLoaded: true,
      };
    default:
      return state;
  }
};

export default audienceBuilder;
